import { useRef, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { maxDate, minDate } from '../../constants';
import styles from './DateInput.module.scss';
import { Input } from 'components/Input/Input';
import { useOutsideClick } from 'hooks';

type Props = {
  labelText?: string;
  inputName: string;
  errorMsg?: string;
  setValue: (value: string) => void;
  register(fieldName: string, registerOptions?: { [key: string]: any }): any;
  registerOptions?: { [key: string]: any };
  triggerValidation: () => void;
  defaultValue?: string;
};

const formatDate = (value: Date) => {
  const formatter = new Intl.DateTimeFormat('en-GB');
  return formatter.format(value);
};

export const DateInput = ({
  inputName,
  register,
  errorMsg,
  labelText,
  registerOptions,
  setValue,
  triggerValidation,
  defaultValue,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const showCalendarButtonRef = useRef<HTMLDivElement | null>() as React.MutableRefObject<HTMLDivElement>;
  const datePickerRef = useOutsideClick<HTMLDivElement>((event) => {
    !showCalendarButtonRef?.current?.contains(event?.target as HTMLElement) && setIsOpen(false);
  });

  const initialCalendarValue = defaultValue ? new Date(defaultValue.split('/').reverse().join('-')) : '';

  return (
    <div className={styles.container}>
      <div onClick={() => setIsOpen((prev) => !prev)} className={styles.dateInputContainer} ref={showCalendarButtonRef}>
        <Input
          inputName={inputName}
          register={register}
          labelText={labelText}
          iconName="Calendar"
          placeholder="DD/MM/YYYY"
          className={styles.dateInput}
          errorMsg={errorMsg}
          registerOptions={registerOptions}
          readOnly
        />
      </div>

      {isOpen && (
        <Calendar
          defaultValue={initialCalendarValue}
          onChange={(value) => {
            value && setValue(formatDate(value as Date));
            setIsOpen(false);
            triggerValidation();
          }}
          inputRef={datePickerRef}
          className={styles.calendar}
          maxDate={maxDate}
          minDate={minDate}
        />
      )}
    </div>
  );
};
